module.exports = require("../../../lib").google.api;
